<template>
  <fb-list-body
      :pagerSizes="[10, 50, 100, 500, 1000]"
      :pager="pager"
      :showBtnGroup="true"
      :showSearchForm="true"
      @handlePagerSizeChange="handlePagerSizeChange"
      @handlePagerIndexChange="handlePagerIndexChange"
  >
    <template slot="btn-group">

      <template v-if="tabCurrent === 1">
        <el-button @click="$router.push('/recipe-add')" >{{ $t('lang.新增') }}</el-button>
        <el-button @click.native="handleBatchSubmitAudit">{{ $t('lang.批量审核') }}</el-button>
      </template>

      <template v-if="tabCurrent === 2">
        <el-button @click="handleBatchRecall()">{{ $t('lang.撤回') }}</el-button>
        <el-button @click.native="handleBatchAuditPass">{{ $t('lang.批量通过') }}</el-button>
      </template>

      <template v-if="tabCurrent === 3">
        <el-button @click="handleBatchRecall()">{{ $t('lang.撤回') }}</el-button>
        <el-button @click="handleMoveCategory">{{ $t('lang.移动') }}</el-button>
        <el-button @click="$router.push('/recipe-model')">{{ $t('lang.批量关联型号') }}</el-button>
      </template>

      <el-button @click.native="handleBatchDelete">{{ $t('lang.批量删除') }}</el-button>
      <el-button @click="$refs.importDialog.showDialog = true ">{{ $t('lang .导入') }}</el-button>
      <el-button @click="handleExport">{{ $t('lang.导出') }}</el-button>

<!--      测试时更改导出条数-->
      <div style="display: flex">
        <div style="opacity: 0;width: 40px;height: 34px;background: pink" @click="handleShowTestPageSizeInput"></div>
        <el-input v-if="changeTestPageSize" v-model="testPageSize" />
      </div>


      <recipe-export ref="exportDialog" :product-list="productList" />
      <recipe-import ref="importDialog" @refresh="handleGetData" />
    </template>

    <template slot="search-form">
      <el-row>
        <el-col style="margin-bottom: 24px">
          <div style="display: flex;justify-content: space-between">
            <el-radio-group v-model="tabCurrent">
              <el-radio-button :label="1">{{ $t('lang.编辑中') }}</el-radio-button>
              <el-radio-button :label="2">{{ $t('lang.待发布') }}</el-radio-button>
              <el-radio-button :label="3">{{ $t('lang.已发布') }}</el-radio-button>
            </el-radio-group>

            <el-button @click="$router.push('/recycling-list')">{{ $t('lang.回收站') }}（{{ countRemove }}）</el-button>

          </div>

        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="search-form-item" :label="$t('lang.语言分类')">
            <el-select clearable v-model="searchForm.lang">
              <el-option v-for="item in supportLangList" :key="item.value" :value="item.value"
                         :label="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.分类')">
            <el-select v-model="searchForm.recipeCategoryCode" clearable :placeholder="$t('lang.请选择')">
              <el-option v-for="i in categoryListByLang" :key="i.recipeCategoryCode" :label="i.name"
                         :value="i.recipeCategoryCode"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.食谱名称')">
            <el-input :placeholder="$t('lang.食谱名称')" v-model="searchForm.name"></el-input>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.食谱编号')">
            <el-input :placeholder="$t('lang.食谱编号')" v-model="searchForm.number" clearable></el-input>
          </el-form-item>


          <el-form-item class="search-form-item" :label="$t('lang.标签')">
            <el-select v-model="searchForm.tag" clearable>
              <el-option v-for="item in recipeTagList" :key="item.recipeTagCode" :label="item.name" :value="item.name"/>
            </el-select>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.食谱类型')">
            <el-select v-model="searchForm.type" clearable>
              <el-option :value="value" :label="$t(`lang.${key}`)" v-for="(key, value, index) in $dict.RECIPE_TYPE" :key="index" />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('lang.按型号筛选')">
            <el-select v-model="searchForm.productCodes" clearable :placeholder="$t('lang.请选择')">
              <el-option v-for="i in productList" :key="i.productCode" :label="i.productModel" :value="i.productCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.食材数量')">
            <el-input v-model="searchForm.foodNumber" clearable :placeholder="$t('lang.食材数量')" />
          </el-form-item>

          <el-form-item :label="$t('lang.按时间排序')">
            <el-select v-model="searchForm.sortType" clearable :placeholder="$t('lang.按时间排序')">
              <el-option value="UPDATE_TIME" :label="$t('lang.是')" />
              <el-option value="" :label="$t('lang.否')" />
            </el-select>
          </el-form-item>

          <el-form-item class="search-form-item" label="">
            <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">
              {{ $t('lang.搜索') }}
            </el-button>
            <el-button size="mini" type="primary" @click="handleReset">{{ $t('lang.重置') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>

    </template>


    <template slot="table">
      <recipe-copy ref="copy" @finish="handleGetData"></recipe-copy>
      <component :is="currentView[tabCurrent]" :tableData="tableData"
                 @remove="handleDelete"
                 @copy="handleCopy"
                 @submit="handleSubmit"
                 @audit="handleAuditSubmit"
                 @recall="handleRecall"
                 @selection-change="handleSelectionChange"></component>
    </template>

    <template slot="other">
      <el-dialog
          :title="$t('lang.移动食谱至此分类')"
          :visible.sync="dialogVisible"
          width="30%">

        <el-form class="dialog-form" :model="categoryForm" ref="categoryForm">
          <el-form-item prop="recipeCategoryCode"
                        :rules="{required: true, message: '请选择食谱分类', trigger: 'change'}">
            <el-select v-model="categoryForm.recipeCategoryCode" :placeholder="$t('lang.请选择')">
              <el-option v-for="i in categoryList" :key="i.recipeCategoryCode" :label="i.name"
                         :value="i.recipeCategoryCode"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleConfirmCategory">{{ $t('lang.确定') }}</el-button>
            <el-button @click="dialogVisible = false">{{ $t('lang.取消') }}</el-button>
          </el-form-item>

        </el-form>
      </el-dialog>
    </template>


  </fb-list-body>
</template>

<script>
import EditorTable from "../../components/editor-table/EditorTable";
import ReleasedTable from "../../components/released-table/ReleasedTable";
import PublishedTable from "../../components/published-table/PublishedTable";
import {filterParams, loadBrandOwnerProduct, loadDict, recipeCategoryList, recipeTagList} from "../../js/common";
import RecipeCopy from "./Copy";
import {handleScrollToTop} from "../../utlis/utlis";
import RecipeExport from "../../components/recipe/RecipeExport";
import RecipeImport from "../../components/recipe/RecipeImport";

// const routerName = ["recipe-detail"];

export default {
  name: "RecipeList",
  components: {
    RecipeImport,
    RecipeExport,
    RecipeCopy,
    EditorTable,
    ReleasedTable,
    PublishedTable
  },
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime();
      },
    },
  },
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        delete: this.$api.recipe.delete,
        submit: this.$api.recipe.submit,
        batchDelete: this.$api.recipe.batchDelete,
        countRemove: this.$api.recipe.countRemove,
        batchRecallEditing: this.$api.recipe.batchRecallEditing,
        batchRecallWaitRelease: this.$api.recipe.batchRecallWaitRelease,
        batchRelease: this.$api.recipe.batchRelease,
        batchSubmit: this.$api.recipe.batchSubmit,
        batchUpdateCategory: this.$api.recipe.batchUpdateCategory,
      },
      searchForm: {status: 'editing'},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0,
      },
      tabCurrent: 1,
      currentView: {
        '1': 'EditorTable',
        '2': 'ReleasedTable',
        '3': 'PublishedTable',
      },
      dialogVisible: false,
      categoryList: [],
      categoryByLang: [],
      statusList: ['editing', 'wait_release', 'released'],
      countRemove: 0,
      categoryForm: {
        recipeCategoryCode: ''
      },
      timerId: null,
      recipeTagList: [],
      changeTestPageSize: false,
      testPageSize: 1,
      testTimeId: null,
      testNum: 0,

      productList: []
    };
  },
  computed: {
    searchParams() {
      console.log('searchForm', this.searchForm);
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
    supportLangList() {
      return this.$store.state.supportLangList;
    },
    categoryListByLang() {
      if (!this.searchForm.lang) return this.categoryList;
      return this.categoryByLang;
    }
  },
  watch: {
    "searchForm.lang": {
      async handler() {
        this.categoryByLang =  await recipeCategoryList(this, {lang: this.searchForm.lang});
      },
    },

    tabCurrent: {
      handler(current) {
        this.searchForm['status'] = this.statusList[current - 1];
        this.handleGetData();
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {

        if (this.timerId) clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          this.$router.updateQuery({
            path: this.$route.path,
            query: this.searchParams,
          });
          this.handleGetData();
        }, 1000)
      },
      deep: true,
      immediate: true,
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams,
        });
        this.handleGetData();
      },
      deep: true,
    },
  },
  methods: {
    handleShowTestPageSizeInput() {
      // 两秒内点击两次则显示输入框
      if (this.changeTestPageSize) {
        this.changeTestPageSize = false;
        return;
      }
      this.testTimeId = setTimeout(() => {
        this.testTimeId = null;
        this.testNum = 0;
      }, 2000)

      // 双击打开
      if(this.testTimeId && this.testNum < 1) {
        this.testNum++;
      } else if(this.testNum === 1) {
        this.changeTestPageSize = true;
      }
    },

    handleExport() {
      let data = {
        ...this.searchForm,
        onPage: false,
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
      };
      if(this.changeTestPageSize) {
        delete data.onPage;
        data.pageSize = this.testPageSize;
        data.pageIndex = 1;
      }
      // delete data.status;
      this.$refs.exportDialog.handleShowExportDialog(data);
    },

    handleConfirmCategory() {
      const vm = this;
      this.$refs.categoryForm.validate(valid => {
        if (valid) {
          let data = {...this.categoryForm};
          data['recipeEditionCodeList'] = [];

          this.selection.forEach(item => {
            data['recipeEditionCodeList'].push(item.releaseEditionCode);
          })
          console.log('data', data)

          vm.$http.post(vm.api.batchUpdateCategory, data).then(res => {
            if (res.data.status != 200) {
              vm.$message.error(res.data.desc);
              return;
            }
            vm.$message.success(res.data.desc);
            vm.dialogVisible = false;
            vm.handleGetData();
          })

        }
      });

    },
    handleMoveCategory() {
      if (!this.selection.length) {
        this.$message({type: "warning", message: this.$t('lang.未选择记录')});
        return;
      }
      this.dialogVisible = true;
    },
    handleBatchRecall() {
      let vm = this;
      let text = this.tabCurrent == '2' ? '撤回编辑中' : '撤回待发布';

      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }

      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t(`lang.您现在正在进行批量${text}, 是否继续?`), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.handleRecall(codes);
          })

    },
    handleRecall(codes) {
      const vm = this;
      let url = this.tabCurrent == '2' ? vm.api.batchRecallEditing : vm.api.batchRecallWaitRelease;
      vm.$http.post(url, codes).then((resp) => {
        if (resp.data.status === 200) {
          vm.$message({type: "success", message: resp.data.desc});
          vm.handleGetData();
        } else {
          vm.$message({type: "error", message: resp.data.desc});
        }
      });
    },
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
      console.log("tab", this.tabCurrent)
    },
    handleReset() {
      console.log('tabCurrent', this.tabCurrent)
      if (Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.searchForm['status'] = this.statusList[this.tabCurrent - 1];
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleGetData();
      }
    },

    handleEdit(e) {
      if (e && e.code) {
        this.$router.push({path: "edit", query: {code: e.code}});
        return;
      }

      if (!this.selection.length) {
        this.$message({type: "warning", message: this.$t('lang.未选择记录')});
        return;
      }

      if (this.selection.length > 1) {
        this.$message({type: "warning", message: this.$t('lang.一次只能编辑一条数据')});
        return;
      }

      this.$router.push({
        path: "edit",
        query: {code: this.selection[0].code},
      });
    },
    handleCopy(row) {
      let vm = this;
      vm.$confirm(vm.$t('lang.您现在正在进行复制操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$refs.copy.copy({recipeEditionCode: row.modifyEditionCode, code: row.code});

          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });

    },
    handleDelete(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http
                .post(vm.api.delete, vm.$qs.stringify({code: row.code}))
                .then((resp) => {
                  if (resp.data.status === 200) {
                    vm.$message({type: "success", message: resp.data.desc});
                    vm.handleGetData();
                  } else {
                    vm.$message({type: "error", message: resp.data.desc});
                  }
                });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },

    handleSubmit(row) {
      const vm = this;
      vm.$http.get(vm.api.submit, {params: {code: row.code}}).then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$message.success(vm.$t('lang.提交成功'));
        vm.handleGetData();
      })
    },

    // 批量提交审核
    handleBatchSubmitAudit() {
      let vm = this;
      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }
      const codes = this.selection.map(item => item.code);
      this.$confirm(vm.$t('lang.您现在正在进行批量审核操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      }).then(async () => {
        const resp = await vm.$http.post(vm.api.batchSubmit, codes);
        if (resp.data.status === 200) {
          vm.$message({type: "success", message: resp.data.desc});
          vm.handleGetData();
        } else {
          vm.$message({type: "error", message: resp.data.desc});
        }
      })
    },

    // 审核通过
    handleBatchAuditPass() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }

      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行批量通过操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
      .then(() => {
        vm.handleAuditSubmit(codes);
      })
    },

    handleAuditSubmit(codes) {
      const vm = this;

      vm.$http.post(this.api.batchRelease, codes).then((resp) => {
        if (resp.data.status === 200) {
          vm.$message({type: "success", message: resp.data.desc});
          vm.handleGetData();
        } else {
          vm.$message({type: "error", message: resp.data.desc});
        }
      });

    },

    handleBatchDelete() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }

      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http.post(this.api.batchDelete, codes).then((resp) => {
              if (resp.data.status === 200) {
                vm.$message({type: "success", message: resp.data.desc});
                vm.handleGetData();
              } else {
                vm.$message({type: "error", message: resp.data.desc});
              }
            });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.$customLoading.showLoading(vm);
      let data = {...this.searchParams};
      data['brandOwnerCode'] = this.$store.state.userInfo['brandOwnerCode'];
      data = filterParams(data);
      this.$http
          .post(this.api.list, this.$qs.stringify(data))
          .then((resp) => {
            this.$customLoading.hideLoading();
            for (let key in resp.data.data) {
              if (resp.data.data[key] instanceof Array) {
                vm.tableData = resp.data.data[key];
              }
            }

            //处理分页
            vm.pager.pageIndex = resp.data.data.pager.pageIndex;
            vm.pager.pageSize = resp.data.data.pager.pageSize;
            vm.pager.itemCount = resp.data.data.pager.itemCount;
            this.$nextTick(() => {
              handleScrollToTop();
            })
          }).catch(() => {
        this.$customLoading.hideLoading();
      });
    },

    handleGetCountRemove() {
      const vm = this;
      vm.$http.get(vm.api.countRemove, {params: {brandOwnerCode: vm.$store.state.userInfo['brandOwnerCode']}}).then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.countRemove = res.data.data['count'];

      })
    }
  },
  activated() {
    this.handleGetData();
  },
  async created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
    window.localStorage.removeItem('recipeData');
    this.categoryList = await recipeCategoryList(this);
    this.recipeTagList = await recipeTagList(this);
    loadDict(this, 'MAKE_MODE', 'ADD_MAKE_MODE');
    this.handleGetCountRemove();
    this.productList = await loadBrandOwnerProduct(this, this.$store.state.userInfo['brandOwnerCode']);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("CHANGE_KEEP_ALIVE_INCLUDE", {type: "add", value: "RecipeList"})
    });
  },
  /*beforeRouteLeave(to, from, next) {
    if (!routerName.includes(to.name)) {
      this.$store.commit("CHANGE_KEEP_ALIVE_INCLUDE", {type: "remove", value: "RecipeList"})
    }
    next();
  },*/
};
</script>

<style scoped>

.dialog-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
